module.exports = __webpack_public_path__ + "img/background.daa16ca6.jpg";